var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ActivatedRoute, Router } from '@angular/router';
import { BookingService } from '@ibe.services/booking.tap.service';
import { MybService } from '@ibe.services/myb.tap.service';
import { SidebarService } from '@ibe/services/ui';
import { ExtraSidebar } from '../ancillaries/extra-sidebar.abstract';
var WifiOnboardComponent = /** @class */ (function (_super) {
    __extends(WifiOnboardComponent, _super);
    function WifiOnboardComponent(sidebarService, route, router, bookingService, mybService) {
        return _super.call(this, sidebarService, route, router, bookingService, mybService) || this;
    }
    return WifiOnboardComponent;
}(ExtraSidebar));
export { WifiOnboardComponent };
